/**
 * Mock Tasks Service
 * Simula el servicio de tareas para testing sin backend
 */

import type { Task } from '@/types/task.types';
import { TaskStatus, TaskSubStatus, ServiceType, CommissionStatus } from '@/types/task.types';

// Mock tasks data
const MOCK_TASKS: Task[] = [
  {
    id: '1',
    doctorId: 'doc-1',
    insurerId: 'ins-1',
    patientName: 'Juan Pérez',
    claimNumber: null,
    description: 'Consulta general - Paciente Juan Pérez',
    type: 'carta_pago',
    serviceType: ServiceType.INVOICING_PLATFORM,
    amount: '2500.00',
    commissionRate: '15.00',
    commissionAmount: '375.00',
    status: TaskStatus.VERIFICACION,
    subStatus: TaskSubStatus.VERIFICACION,
    requiresAlta: false,
    altaFee: '0.00',
    commissionStatus: CommissionStatus.EN_PROCESO,
    paymentReceivedDate: null,
    paymentReceivedAmount: null,
    paymentReference: null,
    paymentProofUrl: null,
    paymentProofS3Key: null,
    commissionBilled: false,
    commissionPaid: false,

    // Payment Complement
    paymentComplementRequired: false,
    paymentComplementAmount: null,
    paymentComplementCfdiUuid: null,
    paymentComplementUploaded: false,
    paymentComplementGeneratedDate: null,
    submittedToInsurerDate: null,
    startDate: new Date('2024-01-15'),
    endDate: null,
    completedAt: null,
    complementUploadedToInsurerAt: null,
    complementInsurerFolio: null,
    createdBy: '1',
    createdAt: new Date('2024-01-15T10:00:00'),
    updatedAt: new Date('2024-01-15T10:00:00'),
    deletedAt: null,
    doctorName: 'Dr. Roberto García',
    doctorEmail: 'roberto.garcia@example.com',
    insurerName: 'Seguros Monterrey',
  },
  {
    id: '2',
    doctorId: 'doc-2',
    insurerId: 'ins-2',
    patientName: 'María López',
    claimNumber: null,
    description: 'Cirugía menor - Paciente María López',
    type: 'reembolso',
    serviceType: ServiceType.COLLECTION_ONLY,
    amount: '15000.00',
    commissionRate: '12.00',
    commissionAmount: '1800.00',
    status: TaskStatus.EN_PROCESO,
    subStatus: TaskSubStatus.INGRESADA,
    requiresAlta: false,
    altaFee: '0.00',
    commissionStatus: CommissionStatus.EN_PROCESO,
    paymentReceivedDate: null,
    paymentReceivedAmount: null,
    paymentReference: null,
    paymentProofUrl: null,
    paymentProofS3Key: null,
    commissionBilled: false,
    commissionPaid: false,

    // Payment Complement
    paymentComplementRequired: false,
    paymentComplementAmount: null,
    paymentComplementCfdiUuid: null,
    paymentComplementUploaded: false,
    paymentComplementGeneratedDate: null,
    submittedToInsurerDate: new Date('2024-01-16'),
    startDate: new Date('2024-01-14'),
    endDate: null,
    completedAt: null,
    complementUploadedToInsurerAt: null,
    complementInsurerFolio: null,
    createdBy: '1',
    createdAt: new Date('2024-01-14T09:30:00'),
    updatedAt: new Date('2024-01-16T14:20:00'),
    deletedAt: null,
    doctorName: 'Dra. Patricia Hernández',
    doctorEmail: 'patricia.hernandez@example.com',
    insurerName: 'GNP Seguros',
  },
  {
    id: '3',
    doctorId: 'doc-2',
    insurerId: 'ins-1',
    patientName: 'Carlos López',
    claimNumber: null,
    description: 'Estudios de laboratorio - Paciente Carlos López',
    type: 'seguimiento_pago',
    serviceType: ServiceType.INVOICING_PLATFORM,
    amount: '3200.00',
    commissionRate: '18.00',
    commissionAmount: '576.00',
    status: TaskStatus.PAGADO,
    subStatus: TaskSubStatus.CONFIRMAR_PAGO,
    requiresAlta: false,
    altaFee: '0.00',
    commissionStatus: CommissionStatus.PENDIENTE,
    paymentReceivedDate: new Date('2024-01-18'),
    paymentReceivedAmount: '3200.00',
    paymentReference: 'REF-2024-001',
    paymentProofUrl: 'https://example.com/proof1.pdf',
    paymentProofS3Key: 's3://bucket/proof1.pdf',
    commissionBilled: true,
    commissionPaid: false,

    // Payment Complement
    paymentComplementRequired: false,
    paymentComplementAmount: null,
    paymentComplementCfdiUuid: null,
    paymentComplementUploaded: false,
    paymentComplementGeneratedDate: null,
    submittedToInsurerDate: new Date('2024-01-12'),
    startDate: new Date('2024-01-10'),
    endDate: new Date('2024-01-18'),
    completedAt: null,
    complementUploadedToInsurerAt: null,
    complementInsurerFolio: null,
    createdBy: '1',
    createdAt: new Date('2024-01-10T11:15:00'),
    updatedAt: new Date('2024-01-18T16:45:00'),
    deletedAt: null,
    doctorName: 'Dr. Miguel Torres',
    doctorEmail: 'miguel.torres@example.com',
    insurerName: 'Seguros Monterrey',
  },
  {
    id: '4',
    doctorId: 'doc-1',
    insurerId: 'ins-3',
    patientName: null,
    claimNumber: 'SIN-2024-001',
    description: 'Urgencia médica - Paciente Ana Martínez',
    type: 'alta_medico',
    serviceType: ServiceType.INVOICING_PLATFORM,
    amount: '8500.00',
    commissionRate: '10.00',
    commissionAmount: '850.00',
    status: TaskStatus.PAGADO,
    subStatus: TaskSubStatus.FINALIZADO,
    requiresAlta: true,
    altaFee: '500.00',
    commissionStatus: CommissionStatus.PAGADA,
    paymentReceivedDate: new Date('2024-01-17'),
    paymentReceivedAmount: '8500.00',
    paymentReference: 'REF-2024-002',
    paymentProofUrl: 'https://example.com/proof2.pdf',
    paymentProofS3Key: 's3://bucket/proof2.pdf',
    commissionBilled: true,
    commissionPaid: true,

    // Payment Complement
    paymentComplementRequired: false,
    paymentComplementAmount: null,
    paymentComplementCfdiUuid: null,
    paymentComplementUploaded: false,
    paymentComplementGeneratedDate: null,
    submittedToInsurerDate: new Date('2024-01-13'),
    startDate: new Date('2024-01-12'),
    endDate: new Date('2024-01-17'),
    completedAt: new Date('2024-01-19T10:00:00'),
    complementUploadedToInsurerAt: null,
    complementInsurerFolio: null,
    createdBy: '1',
    createdAt: new Date('2024-01-12T08:00:00'),
    updatedAt: new Date('2024-01-19T10:00:00'),
    deletedAt: null,
    doctorName: 'Dr. Roberto García',
    doctorEmail: 'roberto.garcia@example.com',
    insurerName: 'Metlife',
  },
  {
    id: '5',
    doctorId: 'doc-2',
    insurerId: null,
    patientName: 'Pedro Sánchez',
    claimNumber: null,
    description: 'Consulta especializada - Paciente Pedro Sánchez',
    type: 'actualizacion_credenciales',
    serviceType: ServiceType.COLLECTION_ONLY,
    amount: '4200.00',
    commissionRate: '15.00',
    commissionAmount: '630.00',
    status: TaskStatus.DETENIDOS,
    subStatus: TaskSubStatus.DOCUMENTOS_VENCIDOS,
    requiresAlta: false,
    altaFee: '0.00',
    commissionStatus: CommissionStatus.EN_PROCESO,
    paymentReceivedDate: null,
    paymentReceivedAmount: null,
    paymentReference: null,
    paymentProofUrl: null,
    paymentProofS3Key: null,
    commissionBilled: false,
    commissionPaid: false,

    // Payment Complement
    paymentComplementRequired: false,
    paymentComplementAmount: null,
    paymentComplementCfdiUuid: null,
    paymentComplementUploaded: false,
    paymentComplementGeneratedDate: null,
    submittedToInsurerDate: null,
    startDate: new Date('2024-01-16'),
    endDate: null,
    completedAt: null,
    complementUploadedToInsurerAt: null,
    complementInsurerFolio: null,
    createdBy: '1',
    createdAt: new Date('2024-01-16T13:00:00'),
    updatedAt: new Date('2024-01-17T09:30:00'),
    deletedAt: null,
    doctorName: 'Dra. Patricia Hernández',
    doctorEmail: 'patricia.hernandez@example.com',
    insurerName: undefined,
  },
  {
    id: '6',
    patientName: null,
    claimNumber: null,
    doctorId: 'doc-3',
    insurerId: 'ins-2',
    description: 'Tratamiento continuo - Paciente Laura Gómez',
    type: 'otro',
    serviceType: ServiceType.INVOICING_EXTERNAL_PORTAL,
    amount: '12000.00',
    commissionRate: '14.00',
    commissionAmount: '1680.00',
    status: TaskStatus.EN_PROCESO,
    subStatus: TaskSubStatus.INGRESADA,
    requiresAlta: false,
    altaFee: '0.00',
    commissionStatus: CommissionStatus.EN_PROCESO,
    paymentReceivedDate: null,
    paymentReceivedAmount: null,
    paymentReference: null,
    paymentProofUrl: null,
    paymentProofS3Key: null,
    commissionBilled: false,
    commissionPaid: false,

    // Payment Complement
    paymentComplementRequired: false,
    paymentComplementAmount: null,
    paymentComplementCfdiUuid: null,
    paymentComplementUploaded: false,
    paymentComplementGeneratedDate: null,
    submittedToInsurerDate: new Date('2024-01-17'),
    startDate: new Date('2024-01-15'),
    endDate: null,
    completedAt: null,
    complementUploadedToInsurerAt: null,
    complementInsurerFolio: null,
    createdBy: '1',
    createdAt: new Date('2024-01-15T14:30:00'),
    updatedAt: new Date('2024-01-17T11:00:00'),
    deletedAt: null,
    doctorName: 'Dr. Miguel Torres',
    doctorEmail: 'miguel.torres@example.com',
    insurerName: 'GNP Seguros',
  },
];

/**
 * Mock get all tasks
 */
export async function mockGetTasks(): Promise<Task[]> {
  await new Promise((resolve) => setTimeout(resolve, 300));
  return MOCK_TASKS;
}

/**
 * Mock get task by ID
 */
export async function mockGetTask(id: string): Promise<Task | null> {
  await new Promise((resolve) => setTimeout(resolve, 200));
  return MOCK_TASKS.find((task) => task.id === id) || null;
}

/**
 * Mock create task
 */
export async function mockCreateTask(data: Partial<Task>): Promise<Task> {
  await new Promise((resolve) => setTimeout(resolve, 400));

  const newTask: Task = {
    id: String(Date.now()),
    doctorId: data.doctorId || 'doc-1',
    insurerId: data.insurerId || null,
    patientName: data.patientName || null,
    claimNumber: data.claimNumber || null,
    description: data.description || '',
    type: data.type || null,
    serviceType: data.serviceType || ServiceType.COLLECTION_ONLY,
    amount: data.amount || '0.00',
    commissionRate: data.commissionRate || '15.00',
    commissionAmount: data.commissionAmount || null,
    status: data.status || TaskStatus.VERIFICACION,
    subStatus: data.subStatus || TaskSubStatus.VERIFICACION,
    requiresAlta: data.requiresAlta || false,
    altaFee: data.altaFee || '0.00',
    commissionStatus: data.commissionStatus || CommissionStatus.EN_PROCESO,
    paymentReceivedDate: null,
    paymentReceivedAmount: null,
    paymentReference: null,
    paymentProofUrl: null,
    paymentProofS3Key: null,
    commissionBilled: false,
    commissionPaid: false,

    // Payment Complement
    paymentComplementRequired: false,
    paymentComplementAmount: null,
    paymentComplementCfdiUuid: null,
    paymentComplementUploaded: false,
    paymentComplementGeneratedDate: null,
    submittedToInsurerDate: null,
    startDate: new Date(),
    endDate: null,
    completedAt: null,
    complementUploadedToInsurerAt: null,
    complementInsurerFolio: null,
    createdBy: '1',
    createdAt: new Date(),
    updatedAt: new Date(),
    deletedAt: null,
    doctorName: data.doctorName || 'Doctor de Prueba',
    doctorEmail: data.doctorEmail || 'doctor@example.com',
    insurerName: data.insurerName || undefined,
  };

  MOCK_TASKS.push(newTask);
  return newTask;
}

/**
 * Mock update task
 */
export async function mockUpdateTask(id: string, data: Partial<Task>): Promise<Task> {
  await new Promise((resolve) => setTimeout(resolve, 300));

  const task = MOCK_TASKS.find((t) => t.id === id);
  if (!task) {
    throw new Error('Task not found');
  }

  const updatedTask: Task = {
    ...task,
    ...data,
    id: task.id,
    doctorId: data.doctorId ?? task.doctorId,
    description: data.description ?? task.description,
    serviceType: data.serviceType ?? task.serviceType,
    amount: data.amount ?? task.amount,
    commissionRate: data.commissionRate ?? task.commissionRate,
    status: data.status ?? task.status,
    subStatus: data.subStatus ?? task.subStatus,
    commissionStatus: data.commissionStatus ?? task.commissionStatus,
    createdBy: task.createdBy,
    createdAt: task.createdAt,
    updatedAt: new Date(),
  };

  const index = MOCK_TASKS.findIndex((t) => t.id === id);
  MOCK_TASKS[index] = updatedTask;

  return updatedTask;
}

/**
 * Mock delete task
 */
export async function mockDeleteTask(id: string): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 200));

  const index = MOCK_TASKS.findIndex((task) => task.id === id);
  if (index !== -1) {
    MOCK_TASKS.splice(index, 1);
  }
}
